export function routes($stateProvider) {
    $stateProvider
        .state('app.financeiro', {
        url: '/financeiro',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.financeiro.list', {
        url: '/iep?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Pedidos de Faturas',
        template: require('./directory/directory.view.html'),
        controller: 'FinanceiroDirectoryController',
        controllerAs: 'vm',
        role: 'faturasLMEEdit',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        // RF-SLC20260926-004 — UI-04-01 — Vista de controlo.
        .state('app.financeiro.faturacaoautomatica', {
        url: '/faturacao-automatica',
        title: 'Financeiro › Faturação Automática',
        template: '<financeiro-faturacao-automatica-list-view></financeiro-faturacao-automatica-list-view>',
        role: ['coreVerFaturacaoAutomatica']
    })
        // RF-SLC20260926-012 — UI-12-01 — Vista de faturas de clientes sem e-mail.
        // Reutiliza a role da vista de controlo (RB-09) — não se cria role nova.
        .state('app.financeiro.faturacaosememail', {
        url: '/faturacao-sem-email',
        title: 'Financeiro › Faturas sem E-mail',
        template: '<financeiro-faturacao-sem-email-list-view></financeiro-faturacao-sem-email-list-view>',
        role: ['coreVerFaturacaoAutomatica']
    });
}
routes.$inject = ['$stateProvider'];
